(() => {
  if (customElements.get('bnz-collection-viewer')) {
    return;
  }

  class BnzCollectionViewer extends HTMLElement {
    constructor() {
      super();

      this.slider = null;
      this.swiper = null;

    }

    connectedCallback() {
      const swiperContainer = this.querySelector('[data-swiper]');
      const flip = this.querySelector('[data-flip]');

      if (!swiperContainer) {
        return;
      }

      const swiperOptions = {
        slidesPerView: 1.3,
        spaceBetween: 20,
        slidesPerGroup: 1,
        centeredSlides: false,
        reverseDirection: flip ? true : false,
        slidesOffsetAfter: 32,
        freeMode: {
          enabled: true,
          sticky: false,
        },
        navigation: {
          nextEl: '.bnz-collection-viewer__arrow-next',
          prevEl: '.bnz-collection-viewer__arrow-prev'
        },
        pagination: {
          el: '.bnz-collection-viewer__pagination',
          type: 'progressbar',
        },
        breakpoints: {
          750: {
            slidesPerView: 1.5,
            spaceBetween: 24,
            slidesOffsetAfter: 0,
            freeMode: {
              enabled: false,
            },
            pagination: {
              enabled: false,
            },
          },
          990: {
            spaceBetween: 32,
            slidesPerView: 2,
            slidesOffsetAfter: 0,
            freeMode: {
              enabled: false,
            },
            pagination: {
              enabled: false,
            },
          },
        }
      };

      this.swiper = new Swiper(swiperContainer, swiperOptions);
    }
  }

  customElements.define('bnz-collection-viewer', BnzCollectionViewer);
})();
